export default {
  'menu.relationships': '关系管理',
  'pages.relationships.action.block': '拉黑',
  'pages.relationships.action.blockConfirm': '确认拉黑该用户？',
  'pages.relationships.action.detail': '详情',
  'pages.relationships.action.refresh': '刷新',
  'pages.relationships.action.reset': '重置',
  'pages.relationships.action.unblock': '取消拉黑',
  'pages.relationships.action.unblockConfirm': '确认取消拉黑该用户？',
  'pages.relationships.block.title': '拉黑关系',
  'pages.relationships.column.action': '操作',
  'pages.relationships.column.addSource': '添加来源',
  'pages.relationships.column.addTime': '添加时间',
  'pages.relationships.column.amBitId': 'AmBit ID',
  'pages.relationships.column.avatarUrl': '头像',
  'pages.relationships.column.blockRelation': '拉黑关系',
  'pages.relationships.column.blockedByUser': '当前用户拉黑对方',
  'pages.relationships.column.blockedUser': '对方拉黑当前用户',
  'pages.relationships.column.createdAt': '创建时间',
  'pages.relationships.column.friendUid': '好友 UID',
  'pages.relationships.column.localProfileFound': '本地资料',
  'pages.relationships.column.nickname': '昵称',
  'pages.relationships.column.raw': '原始数据',
  'pages.relationships.column.relationshipStatus': '关系状态',
  'pages.relationships.column.showId': 'Show ID',
  'pages.relationships.column.status': '状态',
  'pages.relationships.column.timStatus': 'TIM 状态',
  'pages.relationships.column.updatedAt': '更新时间',
  'pages.relationships.column.userId': '用户 ID',
  'pages.relationships.detail.basic': '基础信息',
  'pages.relationships.detail.extra': '其他信息',
  'pages.relationships.detail.relationship': '关系信息',
  'pages.relationships.detail.status': '状态信息',
  'pages.relationships.detail.title': '关系详情：{uid}',
  'pages.relationships.empty.detail': '暂无数据',
  'pages.relationships.empty.result': '暂无操作结果',
  'pages.relationships.field.blockedUid': '被拉黑 UID',
  'pages.relationships.field.blockerUid': '发起拉黑 UID',
  'pages.relationships.field.reason': '原因',
  'pages.relationships.message.missingCurrentUid': '缺少当前查询用户 UID',
  'pages.relationships.message.missingTargetUid': '缺少目标用户 UID',
  'pages.relationships.message.saved': '操作成功',
  'pages.relationships.search.uid': '用户 UID',
  'pages.relationships.title': '关系管理',
  'pages.relationships.unblock.title': '取消拉黑关系',
  'pages.relationships.value.blockRelation.aWithB': '当前用户已拉黑对方',
  'pages.relationships.value.blockRelation.bWithA': '对方已拉黑当前用户',
  'pages.relationships.value.blockRelation.bothWay': '双向拉黑',
  'pages.relationships.value.blockRelation.no': '未拉黑',
  'pages.relationships.value.no': '否',
  'pages.relationships.value.relationship.friend': '好友',
  'pages.relationships.value.yes': '是',
};
